import axios from "axios";
import { useEffect, useState } from "react";
import { FaUsers } from "react-icons/fa";
import StatCard from "./stat_card";

const CardFour = ({ user }) => {
	const [stats, setStats] = useState({
		totalCount: 0,
		verifiedCount: 0,
		unverifiedCount: 0,
	});
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		fetchUserStats();
	}, []);

	const fetchUserStats = async () => {
		try {
			const response = await axios.get(
				`${process.env.REACT_APP_API_URL}/api/v1/users/user-stats`,
				{
					headers: {
						Authorization: `Bearer ${user.token}`,
					},
				}
			);
			const data = await response.data.data;
			setStats(data);
		} catch (error) {
			console.error("Failed to fetch user statistics:", error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<StatCard
			icon={<FaUsers />}
			label="Total Users"
			value={stats.totalCount}
			loading={loading}
			accentBg="bg-sky-50"
			accentText="text-sky-600"
			accentBar="from-sky-500 to-sky-400"
		/>
	);
};

export default CardFour;
